import { AttachMoney} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const lockSalesProfit = {
    id: 'lockSalesProfit',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'lockSalesProfit',
            title: 'Lock Sales Profit',
            type: 'item',
            url: '/lockSalesProfit',
            icon: AttachMoney,
            breadcrumbs: false,
        },
       
    ]
};

export default lockSalesProfit;
